export enum TaskStatus {
    InProgress = "InProgress",
    Success = "Success",
    Error = "Error",
    Cancelled = "Cancelled",
}

export interface TaskInfoError {
    diagnosticMessage: string;
    errorCode: "Cancelled" | "KrecFileNotSupportedError" | "UnexpectedException" | string;
    properties: null | {
        fileCheckResult: unknown;
    };
}

export interface ServerTaskInfo {
    id: string;
    error: TaskInfoError | null;
    progress: { done: number; total: number };
    status: TaskStatus;
}

export interface VerifyAndFixFnsRequirementsTaskInfo {
    type: "VerifyAndFixFnsRequirements";
    attachmentId: string;
}

export type VerifyAndFixFnsRequirementsTask = ServerTaskInfo & VerifyAndFixFnsRequirementsTaskInfo;
export type ServerTask = VerifyAndFixFnsRequirementsTask;
